import React, { useState, useMemo, useEffect } from "react"
import { Button, DialogActions, DialogContent, Divider } from "@mui/material"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import api from "../../../../../base/services/ResApi"
import { FetchErrorHandeling } from "../../../../../base/errorHandeling/FetchErrorHandeling"

const VersionInfo = ({ onClose, grpId }) => {
  console.log(grpId)
  const [appRowCount, setAppRowCount] = useState(0)
  const [approvedData, setApprovedData] = useState([])
  const [apprLoading, setApprDataLoading] = useState(true)

  //for error handling
  const [isUnauhtError, setIsUnauhtError] = useState(false)

  //table state
  const [columnFilters, setColumnFilters] = useState([])
  const [globalFilter, setGlobalFilter] = useState("")

  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 10,
  })

  useEffect(() => {}, [])

  const columns = useMemo(
    () => [
      {
        accessorKey: "appId",
        header: "App ID",
      },
      {
        accessorKey: "appName",
        header: "Name",
      },
      {
        accessorKey: "appVersion",
        header: "Version",
      },
      {
        accessorKey: "versionCode",
        header: "Version Code",
      },
      {
        accessorKey: "uploadOn",
        header: "Upload Date",
      },
    ],
    []
  )

  let apprvConfig = {
    headers: {
      Action: "V_ALL_APPR_APP",
      "Is-Pagination": true,
      "Page-Number": pagination.pageNumber,
      "Page-Size": pagination.pageSize,
      "Sort-Column": "version_code",
      "Sort-Order": "desc",
      Filter: "F_GRP_ID",
      Value: grpId,
    },
  }

  //Approve Data fetch
  useEffect(() => {
    if (grpId) {
      setApprDataLoading(true)
      api
        .get("/applications", apprvConfig)
        .then((res) => {
          setApprovedData(res.data?.dataList)
          setAppRowCount(res.data?.total)
          setApprDataLoading(false)
          setIsUnauhtError(false)
        })
        .catch((error) => {
          console.log(error)
          setApprDataLoading(false)
          FetchErrorHandeling(error, setIsUnauhtError)
        })
    }
    setApprDataLoading(false)
  }, [grpId, isUnauhtError, pagination.pageNumber, pagination.pageSize])

  return (
    <div>
      <br />
      <DialogContent>
        <MaterialReactTable
          columns={columns}
          data={approvedData ?? []}
          state={{
            columnFilters,
            globalFilter,
            pagination,
            showProgressBars: apprLoading,
          }}
          getRowId={(row) => row.phoneNumber}
          initialState={{
            showColumnFilters: false,
            columnVisibility: {
              appId: false,
              versionCode: false,
              createdBy: false,
            },
          }}
          manualPagination
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          rowCount={appRowCount}
          muiTablePaginationProps={{
            rowsPerPageOptions: [10],
          }}
          enableColumnOrdering
          enableGrouping
          enablePinning
        />
        <br />
        <br />
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose} variant="outlined" color="error">
          Cancel
        </Button>
      </DialogActions>
    </div>
  )
}

export default VersionInfo
